<mat-dialog-content class="fullscreen-dialog">
  <app-dialog-header title="Manual Planning" (closeClicked)="onCancelClick()">
  </app-dialog-header>

  @if (!loading && isProject) {
    <section class="section">
      <div class="validation-message invalid-message">
        <mat-icon>close</mat-icon>
        <span
          >This visit is managed by Orchestrator and cannot be moved or locked
          in Resolve</span
        >
      </div>
    </section>
  }
  @if (!loading) {
    <section class="section">
      @if (allowResourceLocking) {
        <h3 class="section-header">Resourcing</h3>
      }
      @if (allowResourceLocking) {
        <div class="row checkbox-with-button">
          <mat-checkbox
            class="form-checkbox"
            (change)="recheckForm(false)"
            [(ngModel)]="lockResource"
            >Lock Resource</mat-checkbox
          >
          <button (click)="changeResource()" color="primary" mat-flat-button>
            Change Resource
          </button>
        </div>
      }
      @if (allowResourceLocking) {
        <div class="row resource-display">
          <div class="resource-info">
            @if (resource && resource.imageUrl) {
              <img [src]="resource.imageUrl" alt="User Image" class="avatar" />
            }
            @if (!resource || !resource.imageUrl) {
              <i class="fas fa-user avatar"></i>
            }
            @if (resource) {
              <div class="resource-name">{{ resource.name }}</div>
            }
            @if (!resource) {
              <div class="resource-name">No Resource Selected</div>
            }
          </div>
        </div>
      }
      @if (allowResourceLocking && hasSkills) {
        <div class="validation-message valid-message">
          <mat-icon>check</mat-icon>
          <span>Has Skills</span>
        </div>
      }
      @if (allowResourceLocking && !hasSkills) {
        <div class="validation-message invalid-message">
          <mat-icon>close</mat-icon>
          <span>Missing Relevant Skills</span>
        </div>
      }
      @if (isForbidden) {
        <div class="validation-message invalid-message">
          <mat-icon>close</mat-icon>
          <span>Forbidden from this Property</span>
        </div>
      }
      @if (invalidResource) {
        <div class="validation-message invalid-message">
          <mat-icon>close</mat-icon>
          <span
            >No Resource Availability at this time for selected Resource</span
          >
        </div>
      }
    </section>
  }
  @if (!loading) {
    <section class="section">
      <h3 class="section-header">Timing</h3>
      <div class="row checkbox-with-input">
        <mat-checkbox
          class="form-checkbox"
          (change)="recheckForm(false)"
          [(ngModel)]="lockTime"
          >Lock Time</mat-checkbox
        >
        <div class="time-input-container">
          <input
            (ngModelChange)="updateAppointmentWindowValidity($event)"
            (input)="onTimeInputChange($event)"
            (change)="onTimeInputChange($event)"
            [(ngModel)]="lockTimeValue"
            matInput
            type="time"
            aria-label="Lock time value"
            placeholder="HH:MM"
          />
        </div>
      </div>
      @if (withinAppointmentWindow) {
        <div class="validation-message valid-message">
          <mat-icon>check</mat-icon>
          <span>Within Appointment Window</span>
        </div>
      }
      @if (!withinAppointmentWindow) {
        <div class="validation-message invalid-message">
          <mat-icon>close</mat-icon>
          <span>{{
            appointmentStartOnly
              ? "Start Time Outside Appointment Window"
              : "Outside Appointment Window"
          }}</span>
        </div>
      }
    </section>
  }

  <!--  <div class="container" *ngIf="!loading">-->
  <!--    <dl>-->
  <!--      <dt>Resource Assignment</dt>-->
  <!--      <dd>{{data.ticket.resourceAvailability.resource.id}} -> {{data.validationState.lastResourceIdValidated}}</dd>-->

  <!--      <dt>Start Time</dt>-->
  <!--      <dd>{{data.origStart | amDateFormat: 'h:mm:ss A' }} -> {{data.startDate  | amDateFormat: 'h:mm:ss A' }}-->
  <!--        ({{data.origStart | amDifference:  data.startDate: 'minutes' }})-->
  <!--      </dd>-->

  <!--      <dt>Duration</dt>-->
  <!--      <dd>{{data.ticket.duration}} mins -> {{data.event.duration}}</dd>-->
  <!--    </dl>-->
  <!--    -->
  <!--  </div>-->

  @if (loading) {
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  }
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button
    (click)="onConfirmClick()"
    [disabled]="loading || invalidResource || isForbidden || isProject"
    color="primary"
    mat-flat-button
  >
    Confirm
  </button>
</mat-dialog-actions>
